import { GetterTree } from 'vuex';
import { AuthStateInterface } from './state';
import { StateInterface } from '../index';


const getters: GetterTree<AuthStateInterface, StateInterface> = {
    someGetter( /* state */ ) {
        // return true;
    }
}



export default getters;